import React, { useEffect, useRef, useState } from 'react'
import BackArrow from '../BackArrow';
import {setAboutContent } from './cl_aboutSlice';
import { useDispatch, useSelector } from 'react-redux';
import { endpoints } from '../../../api/ApiEndPoints';

const About = () => {
  const topRef = useRef(null);

  useEffect(() => {
    topRef.current.scrollIntoView(true);
  }, []);

  const dispatch = useDispatch()
  const brandid=endpoints?.fasFasBrandId || 307;
  const {staticContent}=useSelector((state)=>state?.about);
  const [aboutInfo,setAboutInfo]=useState({});

  useEffect(()=>{
    if(brandid) dispatch(setAboutContent(brandid));
  },[dispatch,brandid]);

  useEffect(()=>{
    if(Array.isArray(staticContent)){
      const staticAboutContent=staticContent?.find(({link_name})=>link_name==='About Us');
      setAboutInfo(staticAboutContent);
    }
  },[staticContent])
  
  return (
    <div className="SB-help" ref={topRef}>
    <div className="SB-pageHeader">
      <div className="SB-pageBackButton">
        <BackArrow />
      </div>
      <div className="SB-pageHeader-title">About Us</div>
    </div>
    <div className="SB-help-content">
      {aboutInfo && Object.keys(aboutInfo).length > 0 &&
         (
          <div dangerouslySetInnerHTML={{ __html:aboutInfo?.is_content }} />
       )
      }
      {/* <h3>How can I play the games?</h3>
      <p>
        To play on the FasFas App (website) simply register to gain free coins!
        These coins can be used to play our Match Predictor, Penalty Shootout
        and Pick 6 Games. Success in these games will give you even more coins
        which can be used to enter additional games or be exchanged for
        prizes. To discover how to play each game see: ‘How To Play’ within
        the games menu.
      </p>

      <h3>How do I register?</h3>
      <p>
        Registering couldn’t be simpler. Just click on ‘register’ on the
        homepage and insert a valid phone number or email address. You will
        then receive a one-time password via SMS or email, and once you chosen
        a password you’ll be registered.
      </p>

      <h3>How can I invite friends to join FasFas?</h3>
      <p>
        There are several ways that you can invite friends to play. You can
        share your selections and invitation link via Telegram, Facebook or
        Twitter. Or you can invite friends directly by entering their details
        directly on the refer and earn screen. Also, please see the Refer and
        Earn tab for more details.
      </p>

      <h3>What are the benefits of inviting friends?</h3>
      <p>
        You will receive 25 coins for every player you refer (with a maximum
        of 20 referrals per week). Adding friends is also a great way to
        compete to see who has the greatest football knowledge. So, you’ll not
        only win coins – you'll win your respect of your invited friends!
      </p> */}
    </div>
  </div>
  )
}

export default About
